export default __webpack_public_path__ + "static/media/IconDesc_Vines.256.5204173e.png";